export const OrientationModes = {
  DIRECTION: 0,
  ROTATION: 1,
  MATRIX: 2,
};

export const ScaleModes = {
  SCALE_BY_CONSTANT: 0,
  SCALE_BY_MAGNITUDE: 1,
  SCALE_BY_COMPONENTS: 2,
};

export default {
  OrientationModes,
  ScaleModes,
};
